export const autoCompoundEvents = `query GetEvents($before: String, $eventType: String) {
  events(last: 10, before: $before, filter:{eventType: $eventType}) {
    pageInfo {
      hasPreviousPage
      startCursor
    }
    nodes {
      type{
        repr
      }
      data
    }
  }
}
`;
//# sourceMappingURL=autoCompoundEvents.js.map